<template>
  <div class="content" v-loadmore="loadMore">
    <div v-for="(item, index) in data" :key="index">
      <div class="time-title">
        {{item.day}}
      </div>
      <div class="vedio-list">
        <div v-for="subitem in item.data" :key="subitem.id">
          <!-- 默认只有 微课 和 体系课两种类型的没费课程 -->
          <router-link class="title-wrap" tag="div" :to="(subitem.model === 1?'/play/'+subitem.id+'/'+subitem.video_ids:'/systematic/'+subitem.id)">
            <span class="iconfont icon-bofang"></span>
            <span class="title">{{subitem.title}}</span>
          </router-link>
          <router-link tag="div" class="who" :to="(subitem.model === 1?'/play/'+subitem.id+'/'+subitem.video_ids:'/systematic/'+subitem.id)">
            <span class="teacher">{{subitem.user_name}}<span><!--明星讲师 九段--></span> </span>
          </router-link>
        </div>
      </div>
    </div>
    <loading :more="more" :loaded="loaded"></loading>
  </div>
</template>
<script>
import Scroll from '../base/scroll/scroll'
import Loading from '../base/loading/loading2'
import {RES_OK, PAGE_SIZE} from '@/api/config'
import {getFreeList} from '@/api/free-course.js'
export default {
  components: {
    Scroll,
    Loading
  },
  data() {
    return {
      loaded: true,
      more: true,
      page: 1,
      data: []
    }
  },
  created() {
    this.loadMore()
  },
  methods: {
    loadMore() {
      this._getFreeList()
    },
    _getFreeList() {
      if (this.loaded && this.more) {
        this.loaded = false
        getFreeList(this.page, PAGE_SIZE).then((res) => {
          let data = res.data
          if (data && data.code === RES_OK && data.data) {
            if (data.data.length) {
              this.data.push(...data.data)
              this.loaded = true
              this.page++
            }
            // 加载完毕
            this.more = this.getDataLen(data.data) >= PAGE_SIZE
          }
        })
      }
    },
    getDataLen(data) {
      let i = 0
      data.forEach(d => {
        i += d.data.length
      })
      return i
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
@import "~common/stylus/variable"
  .content
    padding-bottom size(40)
  .time-title
    background:#f0f0f0
    color:#333
    padding:0 size(30)
    line-height: size(80)
  .vedio-list
    background:#fff
    padding:size(16) size(30)
    color:#333
    line-height size(40)
    .title-wrap
      margin-top size(26)
      padding-left size(55)
      position relative
    .title
      font-size: size(30)
      font-weight:800
    .iconfont
      color:#fe7a18
      float left
      min-width size(55)
      position absolute
      left 0
      top 0
    .who
      text-indent size(55)
      padding size(18) 0
    .teacher
      font-size size(26)
      color #666
      >span
        color #999
</style>



// WEBPACK FOOTER //
// src/components/free-course/free-course.vue